var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "alert-container"
  }, _vm._l(_vm.alerts, function (alert, index) {
    return _c('alert', {
      key: index,
      staticClass: "mr-2",
      attrs: {
        "type": alert.type,
        "auto-close": alert.autoClose
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(alert.message)
      }
    })]);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }